export default {
  background: '#2E3440',
  buttonDark: '#4C566A',
  buttonLight: '#5E81AC',
  buttonBorder: '#5E81AC',
  text: '#FFFFFF',
};
